import img1 from '../images/blog/blog-1.jpg'
import img2 from '../images/blog/blog-2.jpg'
import img3 from '../images/blog/blog-3.jpg'
import img4 from '../images/blog/blog-4.jpg'
const dataBlog = [
    {
        id: 1,
        img: img1,
        title: 'The Next Big Trend In Savings',
        cate: 'Voucher Tips',
        user: '         By Sameer Ahmed',
        time: 'Jan 13, 2026',
        text :'When I started DT Wallet, my vision was simple - make voucher shopping transparent and rewarding. Today, I\'m excited to share how digital vouchers are revolutionizing the way Indians save money. With instant delivery, secure storage, and verified discounts, we\'re building India\'s most trusted voucher marketplace...'
    },
    {
        id: 2,
        img: img2,
        title: 'Smart Shopping With Vouchers',
        cate: 'Voucher Tips',
        user: '         By Sameer Ahmed',
        time: 'Jan 25, 2026',
        text :'After helping thousands of customers save lakhs of rupees, I\'ve learned what makes voucher shopping truly smart. It\'s not just about discounts - it\'s about timing, choosing the right brands, and storing your vouchers safely. At DT Wallet, we\'ve made this process seamless with our digital vault and 24/7 support...'
    },
    {
        id: 3,
        img: img3,
        title: 'Maximize Your Voucher Savings',
        cate: 'Voucher Tips',
        user: '         By Sameer Ahmed',
        time: 'Mar 10, 2026',
        text :'Here\'s my insider tip: stack your savings! Combine our platform discounts with brand offers to get maximum value. I personally test every voucher category on DT Wallet to ensure you\'re getting real, verifiable savings. Our transparent pricing means no hidden fees - what you see is what you pay...'
    },
    {
        id: 4,
        img: img4,
        title: 'Top Brands Partner With Us',
        cate: 'Voucher Tips',
        user: '         By Sameer Ahmed',
        time: 'Apr 17, 2026',
        text :'I\'m proud to announce that DT Wallet now partners with over 100+ top brands across India. From Flipkart to Amazon, Swiggy to BookMyShow - we\'ve negotiated exclusive deals for our community. Every partnership is carefully vetted to ensure you get authentic vouchers with the best possible discounts...'
    },


   
]

export default dataBlog;